<template>
  <section id="home" class="hero" aria-labelledby="hero-heading">
    <div class="hero-video-wrap" aria-hidden="true">
      <video
        ref="videoRef"
        class="hero-video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        poster="../assets/landing2/landingPage.png"
        @loadstart="$emit('video-stage', 'loadstart')"
        @loadedmetadata="$emit('video-stage', 'loadedmetadata')"
        @loadeddata="$emit('video-stage', 'loadeddata')"
        @canplaythrough="$emit('video-stage', 'canplaythrough')"
        @ended="handleEnded"
      >
        <source src="../assets/landing2/Landing_Video2.mp4" type="video/mp4" />
      </video>
    </div>

    <div class="hero-message">
      <h1 id="hero-heading" class="title title-xl">Send love<br />across the world.</h1>
      <p class="subtitle subtitle-hero">
        We make it easy and affordable to ship what matters most to the people
        <br class="hero-subtitle-break">
        who matter most.
      </p>
      <a href="#demo" class="btn btn-primary btn-lg hero-book-btn"
      @click.prevent="scrollToSection('demo')">
        Book a demo
        <b-icon-arrow-right-short
          class="hero-book-btn-arrow"
          font-scale="1.25"
          aria-hidden="true"
        />
      </a>
    </div>
  </section>
</template>

<script>
import scrollToSectionUtil from '../utils/scrollToSection';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2Hero',
  mounted() {
    const video = this.$refs.videoRef;
    if (video) {
      video.play().catch((error) => {
        // eslint-disable-next-line no-console
        console.log('Autoplay blocked by browser policy:', error);
      });
    }
  },
  methods: {
    scrollToSection: scrollToSectionUtil,
    handleEnded() {
      const video = this.$refs.videoRef;
      if (video) {
        video.currentTime = 0;
        video.play().catch((error) => {
          // eslint-disable-next-line no-console
          console.log('Loop playback failed:', error);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.hero {
  position: relative;
  max-width: 85rem;
  height: 44.75rem;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 0 0 2rem 2rem;
}

.hero-video-wrap {
  position: absolute;
  top: 0;
  left: 31.875rem;
  width: 53.125rem;
  height: 44.5625rem;
  background: var(--color-white);
  border-radius: 0 0 2rem 0;
  overflow: hidden;
}

.hero-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-message {
  position: absolute;
  top: 0;
  left: 0;
  width: 53.125rem;
  height: 44.75rem;
  padding: 6.5625rem 0 0 4rem;
  background: linear-gradient(90deg, #FFFFFF 83.5%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0 0 0 2rem;
}

.subtitle-hero {
  max-width: 28rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  line-height: 2.5rem;
  color: var(--color-text-muted);
}

/* the hero button grows an arrow on hover */
.hero-book-btn-arrow {
  max-width: 0;
  margin-left: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-width 0.5s ease, margin-left 0.5s ease, opacity 0.5s ease;
}

.hero-book-btn:hover .hero-book-btn-arrow {
  max-width: 2.25rem;
  margin-left: 0.375rem;
  opacity: 1;
}

@media (max-width: 767px) {
  .hero {
    max-width: none;
    height: auto;
    margin: 0;
    border-radius: 0;
  }

  .hero-video-wrap {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    height: 22.625rem;
    border-radius: 0;
  }

  /* fades the bottom of the video into the white text panel below it */
  .hero-video-wrap::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 16rem;
    background: linear-gradient(0deg, #FFFFFF 10%, rgba(255, 255, 255, 0) 100%);
  }

  .hero-message {
    position: static;
    width: 100%;
    height: auto;
    padding: 0 1.625rem 1rem;
    background: var(--color-white);
    border-radius: 0;
    text-align: center;
  }

  .subtitle-hero {
    max-width: 16.875rem;
    margin-right: auto;
    margin-left: auto;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .hero-subtitle-break {
    display: none;
  }

  .hero-book-btn {
    width: 9rem;
    height: 3rem;
    margin: 0 auto;
    border-radius: 1.5rem;
    font-size: 1rem;
    line-height: 1.1875rem;
    font-weight: 700;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .hero {
    max-width: none;
    height: auto;
    margin: 0;
    border-radius: 0;
  }

  .hero-video-wrap {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    height: fluid(22.625rem, 30rem);
    border-radius: 0;
  }

  .hero-video-wrap::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 16rem;
    background: linear-gradient(0deg, #FFFFFF 10%, rgba(255, 255, 255, 0) 100%);
  }

  .hero-message {
    position: static;
    width: 100%;
    height: auto;
    padding: 0 1.625rem 1rem;
    background: var(--color-white);
    border-radius: 0;
    text-align: center;
  }

  .subtitle-hero {
    max-width: fluid(16.875rem, 28rem);
    margin-right: auto;
    margin-left: auto;
    font-size: fluid(1rem, 1.5rem);
    line-height: fluid(1.5rem, 2.5rem);
  }

  .hero-subtitle-break {
    display: none;
  }

  .hero-book-btn {
    width: fluid(9rem, 14rem);
    height: fluid(3rem, 4rem);
    margin: 0 auto;
    border-radius: fluid(1.5rem, 2rem);
    font-size: fluid(1rem, 1.5rem);
    line-height: fluid(1.1875rem, 1.8125rem);
    font-weight: 700;
  }
}
</style>
